// @flow

import type { InteractivesMenuItemConfig } from "../interactives-list";
import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import DisplayImage from "./image.png";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";

const description =
  "A widget for displaying weather forecasts for major cities across Victoria and New South Wales.";

const CONFIG: InteractivesMenuItemConfig = {
  author: undefined,
  name: "Weather widget",
  id: "weather-widget",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Weather", "Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/weather-widget/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "WeatherWidgetConfigTool" */ "app/components/tools/WeatherWidgetConfigTool/WeatherWidgetConfigTool"),
    loading: DynamicImportLoader,
    modules: ["WeatherWidgetConfigTool"]
  })
};

export default CONFIG;
